import { memo, useMemo } from 'react';
import { Handle, Position } from 'reactflow';
import { Image } from 'react-bootstrap';
import './nodeStyles.css';
import removeNodes from "../../assets/icons/removeNodes.svg";
import addNodes from "../../assets/icons/addNodes.svg";
import { findNextNode } from '../../utilities/Nodes/getConnectedChildNodes';
import { AddButtonNodeProps } from '../../utilities/types/common';
import { handleRemoveConnected } from '../../utilities/Nodes/commonFunctions';
import { useTranslation } from 'react-i18next';
import { useFlowDataContext } from '../../context/workbench/FlowDataContext';
import { AddButtonPopoverAction } from './CommonComponents';
import { usePermission } from '../../hooks/usePermission';

const AddButtonNode = ({ data, id }: AddButtonNodeProps) => {
    const { t } = useTranslation('common');
    const flowDataContext = useFlowDataContext();
    const { canView, canEdit } = usePermission();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const nextNode = useMemo(() => findNextNode(id, flowDataContext?.edges, flowDataContext?.nodes), [flowDataContext?.edges?.length, flowDataContext?.nodes?.length, id]);

    return (
        <div className="add-button-container">
            <div className={`add-button-node ${nextNode?.type === "descriptionNode" ? "paragraph" : nextNode?.type === "stepsNode" ? "steps" : nextNode?.type === "choiceNode" ? "boolean" : nextNode?.type === "linkNode" ? "link" : "answer"}`}>
                <p className="mb-0 button-text">{nextNode?.type === "descriptionNode" ? `${t('buttons.workbench.paragraph')}` : nextNode?.type === "stepsNode" ? `${t('buttons.workbench.steps')}` : nextNode?.type === "choiceNode" ? `${t('buttons.workbench.boolean')}` : nextNode?.type === "linkNode" ? `${t('buttons.workbench.linkModel')}` : `${t('buttons.workbench.answer')}`}</p>
                {
                    canView && canEdit && (
                        <>
                            <AddButtonPopoverAction data={data} id={id} />
                            <Image src={nextNode?.type === "descriptionNode" || nextNode?.type === "stepsNode" || nextNode?.type === "choiceNode" || nextNode?.type === "linkNode" ? removeNodes : addNodes} alt="removeIcon" className="removeIcon pe-2" onClick={() => { handleRemoveConnected(data, id); }} />
                        </>
                    )
                }
                <Handle type="target" position={Position.Left} className="handle" id="left-handle" />
                <Handle type="source" position={Position.Right} className="handle" id="right-handle" />
            </div>
        </div>
    );
};

export default memo(AddButtonNode);